module.exports = __webpack_public_path__ + "img/s2P17.0ea06d4b.png";